
const PatternTokenizer = require("./patternTokenizer");
class WhiteSpace extends PatternTokenizer {
    constructor() {
        super("whitespace", /^\s*$/);
    }

    getToken(text, currentPosition) {
        const [consumedChars, token] = super.getToken(text, currentPosition);
        if (token && token.value) {
            token.value = null;
        }
        return [consumedChars, token];
    }
}

module.exports = WhiteSpace;